var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.914,
    height: 16,
    viewBox: "0 0 15.914 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:gray;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-756.386 -186.49)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M763.669,187.772v6.508H772.3V186.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M756.386,194.355h6.743v-6.521l-6.743,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M763.669,201.209l8.631,1.281v-7.6h-8.631Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M756.386,200.151l6.743,1v-6.252h-6.743Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWindows);
export default __webpack_public_path__ + "static/media/icon-windows.3e8381464b5155204717d435a573762a.svg";
export { ForwardRef as ReactComponent };